'use client';

import cx from 'classix';
import { useAtomValue } from 'jotai/index';
import { useSearchParams } from 'next/navigation';
import {
  useEffect,
  useState,
} from 'react';

import ListingBudgetFilter
  from '@/features/listing/components/listings-filters/listing-budget-filter/listing-budget-filter';
import ListingDetailedFilters
  from '@/features/listing/components/listings-filters/listing-detailed-filters/listing-detailed-filters';
import ListingSort from '@/features/listing/components/listings-filters/listing-sort/listing-sort';
import ListingTypeFilter from '@/features/listing/components/listings-filters/listing-type-filter/listing-type-filter';
import ListingViewSelect from '@/features/listing/components/listings-filters/listing-view-select/listing-view-select';
import { type ListingsFilterName } from '@/features/listing/types/listing-filters-types';
import { isBannerClosedAtom } from '@/features/roomster-app/atoms/is-banner-closed-atom';
import { usePathname } from '@/i18n/routing';

import styles from './listings-filters.module.scss';

export default function ListingsFilters() {
  const [activeFilter,
    setActiveFilter] = useState<ListingsFilterName | null>(null);

  const isBannerClosed = useAtomValue(isBannerClosedAtom);

  const searchParams = useSearchParams();
  const pathname = usePathname();

  const [filterLink,
    setFilterLink] = useState<{
    pathname: string;
    searchParams: URLSearchParams;
  }>({
    pathname,
    searchParams: new URLSearchParams(searchParams.toString()),
  });

  useEffect(() => {
    setFilterLink({
      pathname,
      searchParams: new URLSearchParams(searchParams.toString()),
    });
  }, [pathname, searchParams]);

  return (
    <div
      className={cx(
        styles.listingsFilters,
        activeFilter && styles.listingsFilters__isActive,
        !isBannerClosed && styles.listingsFilters__withAppBanner,
      )}
    >
      <div className={styles.listingsFilters_item}>
        <ListingViewSelect
          onFilterDisplayChange={setActiveFilter}
        />
      </div>

      <div className={styles.listingsFilters_item}>
        <ListingTypeFilter
          filterLink={filterLink}
          onFilterDisplayChange={setActiveFilter}
        />
      </div>

      <div className={styles.listingsFilters_item}>
        <ListingBudgetFilter
          filterLink={filterLink}
          setFilterLink={setFilterLink}
          onFilterDisplayChange={setActiveFilter}
        />
      </div>

      <div className={styles.listingsFilters_item}>
        <ListingDetailedFilters
          filterLink={filterLink}
          setFilterLink={setFilterLink}
          onFilterDisplayChange={setActiveFilter}
        />
      </div>

      <div className={styles.listingsFilters_item}>
        <ListingSort
          filterLink={filterLink}
          onFilterDisplayChange={setActiveFilter}
        />
      </div>
    </div>
  );
}
